import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-lg w-full border border-white/10 bg-white/[0.02] p-10 text-center rounded-sm">
        <span className="micro-label inline-block">Paiement interrompu</span>
        <h1 className="font-display text-3xl mt-6">Aucun montant n'a été débité.</h1>
        <p className="mt-4 text-[15px] text-[#D8D4CC]">
          Vous avez quitté la page de paiement. La formation MULTIPOLAR vous attend
          quand vous serez prêt : l'offre reste identique.
        </p>
        <Link
          to="/#tarif"
          data-testid="cancel-retry-link"
          className="mt-8 inline-flex items-center gap-3 bg-[#D92D20] hover:bg-[#b3241a] text-white font-mono text-xs tracking-[0.2em] uppercase px-8 py-4 rounded-sm transition-colors"
        >
          <ArrowLeft size={14} />
          Revenir à l'offre
        </Link>
      </div>
    </main>
  );
}
